<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity" :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter" :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesPrdPowerStationRecordResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="openCreateDialog()"
                                    >
                                        创建输入项
                                    </b-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="创建输入项" :visible.sync="createDialogVisible" :close-on-click-modal='false' append-to-body @close='clearCreateForm'>
            <el-form :model="createForm" ref="createForm" label-width="auto" width="30%" :inline="true" :rules="rules">
                <el-form-item label="记录时间" prop="requiredTime">
                    <el-date-picker v-model="createForm.recordTime" type="datetime" placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="班组" prop="shiftId">
                    <el-select v-model="createForm.shiftId" placeholder="请选择">
                        <el-option v-for="shift in shiftOptions" :key="shift.id" :label="shift.name" :value="shift.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="createBasicRecords()">创建</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-11-03 21:01:58

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import emCommonApiMixin from "@/mixin/em/common/api";

    export default {
        name: "mintalMesPrdPowerStationRecordListView",
        mixins: [emCommonListMixin,emCustomVuexMixin,emCommonApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                createDialogVisible: false,
                createForm: {
                    recordTime: '',
                    shiftId: ''
                },
                shiftOptions:[],
                rules: {
                    recordTime: [{required: true, message: '请选择日期时间'}],
                    shiftId: [{require:true,message:'请选择班组',trigger:'change',type:'number'}]
                },
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        },
        methods: {
            openCreateDialog() {
                this.createDialogVisible = true;
            },
            clearCreateForm() {
                this.createForm.recordTime = '';
                this.createForm.shiftId = '';
            },
            getShiftOptinos() {
                this.$_emApiMixin_findByFilter("imfMstShift", {})
                .then(data => {
                    this.shiftOptions = data.map(m => {
                        return {id: m.id, name: m.name}
                    })
                })
            },
            createBasicRecords() {
                let self = this;
                self.$refs["createForm"].validate(valid => {
                    if(valid) {
                        let url = `${this.$_emApiMixin_entityBaseApi("mintalMesPrdPowerStationRecord")}/createBasicRecords?recordTime=${self.createForm.recordTime}&shiftId=${self.createForm.shiftId}`;
                        self.$_emApiMixin_post(url, {})
                            .then((request) => {
                                if (request.status === 200) {
                                    self.$message({
                                        message: "创建成功",
                                        type: "success",
                                    });

                                } else {
                                    self.$message({
                                        message: "创建失败",
                                        type: "error",
                                    });
                                }
                            }).finally(() => {
                            this.createDialogVisible = false;
                        })
                    } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
                })
            }
        },
        mounted() {
            this.getShiftOptinos();
        }
    };
</script>
